import { render, staticRenderFns } from "./FormSemester.vue?vue&type=template&id=53d5480c&scoped=true&"
import script from "./FormSemester.vue?vue&type=script&lang=js&"
export * from "./FormSemester.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d5480c",
  null
  
)

export default component.exports